export class CercaTecniciModel {
    provincia: string = "";
    localita: string = "";
    nome: string = "";
}